var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecondIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.556,
    height: 133.247,
    viewBox: "0 0 150.556 133.247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.452,334.244l26.666,8.962,11.69-11.521Z",
    transform: "translate(-354.452 -331.685)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -9.67,
    y1: 22.09,
    x2: -9.669,
    y2: 22.09,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d5d7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97.141,
    height: 80.362,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.968,309.816c-18.315-9.948-35.67-2.217-48.167-14.986-7.7-7.86-9.107-18.987-8.876-27.7l-11.723-.365a1.863,1.863,0,0,0-1.985,2.323l15.091,75.8a2.829,2.829,0,0,0,2.888,2.223l79.1-5.708c-8.646-18.77-18.393-27.275-26.33-31.588",
    transform: "translate(-365.157 -266.756)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -2.031,
    y1: 2.651,
    x2: -2.031,
    y2: 2.651,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.649,271.27a2.03,2.03,0,0,0-1.468,2.467v0l13.45,67.533a3.065,3.065,0,0,0,3.114,2.41l86.353-5.893a1.977,1.977,0,0,0,.329-.069,1.887,1.887,0,0,0,1.259-2.353v0l-11.856-59.6a2.893,2.893,0,0,0-2.538-2.339l-87.974-2.212c-.057,0-.113-.007-.169-.007a2,2,0,0,0-.5.064",
    transform: "translate(-368.118 -271.206)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -3.662,
    y1: 4.637,
    x2: -3.662,
    y2: 4.637,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.688,
    height: 55.891,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.272,335.718l-9.956.621a.642.642,0,0,1-.648-.509l-1.612-8.089a.459.459,0,0,1,.334-.554.394.394,0,0,1,.1-.014l9.977-.507a.637.637,0,0,1,.629.507l1.589,7.973a.456.456,0,0,1-.322.559h0a.335.335,0,0,1-.1.014m-9.628-.494,8.889-.543-1.375-6.917-8.908.461Z",
    transform: "translate(-385.043 -326.666)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -15.643,
    y1: 14.081,
    x2: -15.64,
    y2: 14.081,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.257,
    height: 72.442,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.625,338.949a4.925,4.925,0,0,0-4.531,4.744v1.642a3.788,3.788,0,0,0,.049.616,3.921,3.921,0,0,0,4.482,3.261l39.7-4.435c-2.163-2.66-1.757-5.719,0-8.993Z",
    transform: "translate(-367.094 -335.785)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -4.159,
    y1: 10.131,
    x2: -4.159,
    y2: 10.131,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dadbdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdbfc1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.848,322.819a6.916,6.916,0,0,0-6.754,6.767v2.465a6.122,6.122,0,0,0,6.754,6.07l37.476-2.83c-2.159-4-1.763-8.593,0-13.5Z",
    transform: "translate(-367.094 -321.795)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: -4.34,
    y1: 9.205,
    x2: -4.34,
    y2: 9.205,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.754,240.813c-.943.686-2.751,2.324-2.767,2.842-.014.427,4.332-1.695,6.028-2.541a1.277,1.277,0,0,0,.709-1.126c.005-.524-.031-1.128-.246-1.2a.192.192,0,0,0-.06-.008,14.949,14.949,0,0,0-3.668,2.032",
    transform: "translate(-365.987 -238.781)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: -57.292,
    y1: 61.522,
    x2: -57.252,
    y2: 61.522,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9eaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101011"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.353,240.742a.862.862,0,0,0-.116.03.646.646,0,0,0-.411.481l-.65,3.167,2.342-.72-.419-2.427a.646.646,0,0,0-.637-.539.581.581,0,0,0-.1.008",
    transform: "translate(-370.176 -240.735)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: -136.766,
    y1: 69.089,
    x2: -136.549,
    y2: 69.089,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6f72"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.891,244.077l1.921.143-.078-2.487-1.217-.367Z",
    transform: "translate(-379.891 -241.366)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: -176.013,
    y1: 85.242,
    x2: -175.683,
    y2: 85.242,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.466,239.17a1.961,1.961,0,0,0,.986,1.845c1.194.8,3.968,2.82,4.7,2a.445.445,0,0,0,.031-.046,1.191,1.191,0,0,0-.306-1.657l0,0a21.266,21.266,0,0,0-3.012-1.7,4.157,4.157,0,0,0-1.916-.727c-.266,0-.443.088-.481.285",
    transform: "translate(-376.461 -238.884)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: -65.146,
    y1: 65.168,
    x2: -65.097,
    y2: 65.168,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.976,231.52a11.37,11.37,0,0,0-9.149,10.411c-.181,5.653,4.739,10.613,8.92,11.4,1.622.3,3.7.09,6,1.607a11.276,11.276,0,0,1,2.583,2.589c3.954,4.379,14.56,3.683,20.137-.884a10.46,10.46,0,0,0,2.589-3.589c.7-1.4,1.11-2.219.965-3.26a4.967,4.967,0,0,0-4.182-3.773c-1.828-.245-2.41.88-4.516,1.247-3.471.6-6.558-1.643-7.159-2.08-3.859-2.811-2.394-6-5.869-9.746-.217-.235-3.871-4.053-8.779-4.053a9.34,9.34,0,0,0-1.548.129",
    transform: "translate(-383.822 -231.387)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: -9.687,
    y1: 12.233,
    x2: -9.686,
    y2: 12.233,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.417,252.295c-4.433.018-5.03,3.1-8.651,3.258-3.089.135-3.421-2.066-8.214-2.487-1.219-.1-4.418-.386-4.873.951-.411,1.2,1.814,2.464,4.29,6.19,3.313,4.984,2.235,7.089,4.521,8.7,2.083,1.467,4.778.973,10.259-.2,4.229-.9,6.377-1.39,7.965-3.235,2.274-2.638,3.6-7.345,2.127-9.933-.789-1.382-2.272-1.96-3.683-2.528a10.114,10.114,0,0,0-3.732-.715h-.013",
    transform: "translate(-392.63 -252.295)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: -8.637,
    y1: 12.988,
    x2: -8.636,
    y2: 12.988,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b4d50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#363739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363739"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.474,
    height: 16.406,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.436,252.374c-2.608-.1-3.23.179-3.3.472-.113.456,1.136.838,2.984,2.384,2.027,1.7,2.344,2.748,3.184,2.627a2.38,2.38,0,0,0,1.5-2.821,3.11,3.11,0,0,0-1.292-1.167c-.618-.365-.872-.354-1.012-.611-.153-.289-.1-.849.88-2.031-.565-.129-.471-.59-1.035-.717-.414.509-1.491,1.356-1.905,1.863",
    transform: "translate(-412.127 -250.51)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: -43.933,
    y1: 36.021,
    x2: -43.915,
    y2: 36.021,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.454,249.95c-.083-.3-.271-.512-.481-.524a.385.385,0,0,0-.21.052c-.29.181-.243.647.19,1.146a2.257,2.257,0,0,0,1.071,2.083c1.048.505,2.638-1.93,2.262-2.784a1.542,1.542,0,0,0-.943-.734,1.883,1.883,0,0,0-.419-.041,1.518,1.518,0,0,0-1.476.8",
    transform: "translate(-416.58 -249.143)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: -59.978,
    y1: 45.923,
    x2: -59.945,
    y2: 45.923,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.785,264.749l.083,1.023a7.931,7.931,0,0,1,2.515.357c1.231.386,1.8.9,1.969.719.241-.251-.406-1.726-1.664-2.3a3.422,3.422,0,0,0-2.9.2",
    transform: "translate(-417.785 -264.319)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: -77.577,
    y1: 82.686,
    x2: -77.522,
    y2: 82.686,
    xlinkHref: "#s"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-550.162 -163.005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.348,237.994a62.977,62.977,0,1,1-62.983,62.983,62.977,62.977,0,0,1,62.983-62.983h0",
    transform: "translate(224.027 -68.064)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.368,364.333a63.347,63.347,0,1,1,63.338-63.356h0v.007a63.42,63.42,0,0,1-63.34,63.348m0-125.955a62.608,62.608,0,1,0,62.606,62.61v0h0a62.681,62.681,0,0,0-62.6-62.608",
    transform: "translate(224.01 -68.081)",
    fill: "#d9dadc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.112,242.91a57.82,57.82,0,1,1-57.82,57.823,57.82,57.82,0,0,1,57.82-57.823h0",
    transform: "translate(224.264 -67.828)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.2,268.192,354.82,334.8a1.98,1.98,0,0,0,1.527,2.347,2.076,2.076,0,0,0,.361.042l51.964-2.451Z",
    transform: "translate(224.335 -66.615)",
    fill: "#8a8d90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.416,325.252s-7-14.672-15.632-15.163-22.561,3.5-33.577-17.062c-6.445-12.039-9.449-17.215-10.823-19.429a1.54,1.54,0,0,1,.5-2.121,1.5,1.5,0,0,1,.377-.169c6.925-2.011,29.945-7.511,41.346,4.325,13.515,14.026,17.811,49.62,17.811,49.62",
    transform: "translate(223.01 -66.612)",
    fill: "#6e7073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.687,274.326c10.074,2.676,23.643,9.562,33.469,18.348a57.8,57.8,0,0,1,9.165,11.019,64.45,64.45,0,0,1,7.5,15.9.52.52,0,0,1-1,.3,71.261,71.261,0,0,0-13.072-22.146c-7.272-8.1-17.5-14.33-27.236-19.089l-.984-.455c-7.446-3.51-8.421-3.072-8.2-3.688a.3.3,0,0,1,.357-.189",
    transform: "translate(223.401 -66.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.149,341.827c1.123-.085-14.769-6.183-28.258-22.521-6.354-7.7-12.649-18.332-19.9-19.581-6.041-1.04-18.475,9.2-22.474,12.66a.78.78,0,0,0,.38,1.362c3.216.538,10.328,2.085,14.055,5.671,4.915,4.726,12.417,5.155,17.807,3.289s8.628-2.5,15.51,3.82,19.684,15.553,22.877,15.3",
    transform: "translate(223.734 -65.106)",
    fill: "#7a7e81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.869,310.671c5.862-3.131,13.541-4.144,19.544-1.087l.57.294a127.509,127.509,0,0,1,15.708,11.4.181.181,0,0,1,.018.252h0a.18.18,0,0,1-.245.021c-3.641-2.767-8.506-6.129-12.249-8.58-4.053-2.694-6.837-4.495-12.448-4.484A26.955,26.955,0,0,0,350,310.921a.144.144,0,0,1-.128-.258Z",
    transform: "translate(224.096 -64.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(578.771 268.115)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.356,
    height: 11.521,
    fill: "url(#b)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589.489 200.075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.771,269.648l-93.05-2.88a1.862,1.862,0,0,0-1.983,2.321l15.091,75.8a2.829,2.829,0,0,0,2.888,2.223l91.163-6.586a1.741,1.741,0,0,0,1.447-2.238l-13.234-66.485a2.681,2.681,0,0,0-2.323-2.159",
    transform: "translate(-364.679 -266.76)",
    fill: "#8a8d90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.248,269.648l-93.048-2.88a1.862,1.862,0,0,0-1.985,2.321l15.091,75.8a2.829,2.829,0,0,0,2.888,2.223l91.163-6.586a1.741,1.741,0,0,0,1.513-1.941,1.934,1.934,0,0,0-.063-.3l-13.237-66.485a2.68,2.68,0,0,0-2.323-2.159",
    transform: "translate(-364.656 -266.76)",
    fill: "#8a8d90"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.502 0.002)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.001 -0.007)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36.405 -30.139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.418,281.585l52.726,97.032L500.36,335.027,447.633,238Z",
    transform: "translate(-330.418 -237.996)",
    fill: "url(#e)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(593.093 204.734)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.21 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105.089,
    height: 72.538,
    fill: "url(#g)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M471.473,337.766l-86.256,5.888a3.065,3.065,0,0,1-3.116-2.41l-13.437-67.49a2.024,2.024,0,0,1,2.133-2.523l87.867,2.2a2.9,2.9,0,0,1,2.533,2.335l11.863,59.567a1.887,1.887,0,0,1-1.249,2.358h0a1.917,1.917,0,0,1-.334.07",
    transform: "translate(224.998 -66.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(601.43 216.641)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.994,294.864l-9.415.057a.656.656,0,0,1-.615-.524l-1.557-7.812a.4.4,0,0,1,.266-.506.417.417,0,0,1,.139-.018l9.441.052a.651.651,0,0,1,.6.518l1.537,7.715a.407.407,0,0,1-.279.5.462.462,0,0,1-.119.016m-9.112-.991,8.408-.042-1.331-6.689-8.426-.036Z",
    transform: "translate(-374.858 -282.398)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.332,294.786l-9.117.057a.641.641,0,0,1-.6-.509l-1.532-7.694a.4.4,0,0,1,.277-.494.379.379,0,0,1,.118-.014l9.135.051a.637.637,0,0,1,.585.507l1.511,7.59a.4.4,0,0,1-.277.492.4.4,0,0,1-.1.014m-8.823-.976,8.14-.037-1.312-6.583-8.152-.036Z",
    transform: "translate(-374.298 -282.395)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.313,294.719l-8.832.052a.628.628,0,0,1-.58-.507l-1.508-7.573a.393.393,0,0,1,.257-.489.437.437,0,0,1,.122-.018l8.85.051a.629.629,0,0,1,.567.507l1.486,7.469a.388.388,0,0,1-.25.488h0a.4.4,0,0,1-.111.019m-8.549-.962,7.883-.037-1.291-6.48-7.9-.034Z",
    transform: "translate(-373.756 -282.392)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.952,294.644l-8.553.052a.616.616,0,0,1-.565-.495l-1.483-7.453a.384.384,0,0,1,.248-.481.416.416,0,0,1,.118-.018l8.573.047a.613.613,0,0,1,.551.5l1.467,7.355a.382.382,0,0,1-.25.477.392.392,0,0,1-.1.018m-8.287-.943,7.64-.037-1.273-6.379-7.65-.034Z",
    transform: "translate(-373.23 -282.389)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.267,294.575l-8.294.051a.6.6,0,0,1-.548-.488l-1.46-7.336a.37.37,0,0,1,.235-.468l.005,0a.414.414,0,0,1,.113-.019l8.313.046a.6.6,0,0,1,.535.488l1.442,7.242a.373.373,0,0,1-.238.471.357.357,0,0,1-.1.019m-8.038-.934,7.409-.036-1.25-6.28-7.418-.03Z",
    transform: "translate(-372.721 -282.386)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.2,305.2l-10.036.2a.682.682,0,0,1-.653-.53l-1.61-8.09a.434.434,0,0,1,.31-.529h0a.417.417,0,0,1,.125-.014l10.061-.085a.673.673,0,0,1,.637.53l1.589,7.973a.431.431,0,0,1-.308.524.364.364,0,0,1-.116.014m-9.707-.89,8.964-.168-1.377-6.917-8.98.088Z",
    transform: "translate(-375.938 -281.914)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.275,304.949l-9.705.2a.658.658,0,0,1-.629-.524l-1.591-7.951a.429.429,0,0,1,.3-.524h0a.386.386,0,0,1,.12-.014l9.728-.081a.659.659,0,0,1,.618.524l1.563,7.842a.419.419,0,0,1-.286.519.407.407,0,0,1-.123.017m-9.39-.879,8.667-.162-1.349-6.8-8.68.085Z",
    transform: "translate(-375.341 -281.919)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.957,304.707l-9.389.189a.646.646,0,0,1-.609-.512L403.4,296.56a.419.419,0,0,1,.292-.512.349.349,0,0,1,.114-.014l9.41-.078a.647.647,0,0,1,.6.507l1.535,7.714a.419.419,0,0,1-.282.515.439.439,0,0,1-.116.016m-9.087-.867,8.384-.157-1.333-6.69-8.4.081Z",
    transform: "translate(-374.763 -281.924)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.257,304.473l-9.089.183a.628.628,0,0,1-.6-.51l-1.529-7.692a.4.4,0,0,1,.276-.5h0a.35.35,0,0,1,.114-.016l9.11-.075a.629.629,0,0,1,.585.507l1.509,7.59a.408.408,0,0,1-.279.5.588.588,0,0,1-.1.016m-8.8-.856,8.121-.152-1.31-6.584-8.131.081Z",
    transform: "translate(-374.204 -281.928)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.209,304.248l-8.8.176a.614.614,0,0,1-.58-.5l-1.508-7.573a.4.4,0,0,1,.272-.49h0a.352.352,0,0,1,.1-.018l8.823-.072a.619.619,0,0,1,.567.5l1.488,7.472a.4.4,0,0,1-.267.489.444.444,0,0,1-.1.016m-8.525-.846,7.86-.146-1.291-6.481-7.874.075Z",
    transform: "translate(-373.663 -281.932)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.819,304.026l-8.527.173a.61.61,0,0,1-.562-.492l-1.483-7.453a.385.385,0,0,1,.253-.483h0a.325.325,0,0,1,.1-.018l8.55-.072a.6.6,0,0,1,.551.489l1.467,7.353a.388.388,0,0,1-.252.486.4.4,0,0,1-.1.018m-8.266-.838,7.614-.14-1.271-6.379-7.629.074Z",
    transform: "translate(-373.139 -281.937)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.106,303.812l-8.269.168a.587.587,0,0,1-.546-.482l-1.462-7.336a.381.381,0,0,1,.246-.477.437.437,0,0,1,.1-.018l8.287-.069a.589.589,0,0,1,.536.479l1.442,7.244a.378.378,0,0,1-.245.476h0a.338.338,0,0,1-.1.018m-8.018-.823,7.384-.137-1.25-6.288-7.4.072Z",
    transform: "translate(-372.631 -281.941)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.222,315.381l-10.008.342a.667.667,0,0,1-.652-.524l-1.612-8.1a.445.445,0,0,1,.323-.541.436.436,0,0,1,.116-.013l10.031-.225a.664.664,0,0,1,.636.524l1.589,7.974a.439.439,0,0,1-.311.538h0a.447.447,0,0,1-.1.016m-9.681-.759,8.939-.294-1.377-6.917-8.954.21Z",
    transform: "translate(-375.84 -281.426)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.264,314.954l-9.679.331a.655.655,0,0,1-.629-.515l-1.59-7.953a.435.435,0,0,1,.31-.531h0a.5.5,0,0,1,.111-.014l9.7-.215a.646.646,0,0,1,.616.515l1.563,7.841a.428.428,0,0,1-.3.524.352.352,0,0,1-.1.016m-9.364-.75,8.644-.284-1.354-6.8-8.659.2Z",
    transform: "translate(-375.244 -281.439)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.912,314.553l-9.364.321a.629.629,0,0,1-.608-.507l-1.558-7.823a.419.419,0,0,1,.284-.52l.014,0a.441.441,0,0,1,.1-.014l9.385-.21a.628.628,0,0,1,.6.507l1.537,7.714a.421.421,0,0,1-.291.517h-.006a.393.393,0,0,1-.1.014m-9.063-.743,8.362-.272-1.333-6.69-8.376.2Z",
    transform: "translate(-374.668 -281.452)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.188,314.158l-9.063.3a.623.623,0,0,1-.6-.5l-1.532-7.7a.42.42,0,0,1,.287-.509.586.586,0,0,1,.1-.016l9.084-.2a.617.617,0,0,1,.583.5l1.511,7.59a.413.413,0,0,1-.276.514.446.446,0,0,1-.1.017m-8.776-.734,8.092-.264-1.31-6.583-8.108.19Z",
    transform: "translate(-374.11 -281.464)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.106,313.777l-8.778.3a.61.61,0,0,1-.577-.491l-1.508-7.572a.406.406,0,0,1,.278-.5h0a.5.5,0,0,1,.1-.016l8.8-.2a.6.6,0,0,1,.565.489l1.488,7.471a.409.409,0,0,1-.289.5.486.486,0,0,1-.078.013m-8.5-.734,7.839-.257-1.291-6.48-7.852.187Z",
    transform: "translate(-373.571 -281.475)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.69,313.409l-8.506.292a.6.6,0,0,1-.562-.482l-1.485-7.453a.4.4,0,0,1,.267-.494.5.5,0,0,1,.1-.016l8.525-.189a.594.594,0,0,1,.551.482l1.467,7.355a.391.391,0,0,1-.261.487h0a.421.421,0,0,1-.088.016m-8.243-.72,7.6-.248-1.271-6.379-7.614.181Z",
    transform: "translate(-373.048 -281.486)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.942,313.051l-8.245.282a.578.578,0,0,1-.544-.476l-1.462-7.336a.383.383,0,0,1,.249-.481h0a.381.381,0,0,1,.1-.018l8.266-.184a.582.582,0,0,1,.535.476l1.442,7.242a.386.386,0,0,1-.253.484h0a.419.419,0,0,1-.088.016m-7.994-.709,7.365-.241-1.252-6.28-7.378.174Z",
    transform: "translate(-372.542 -281.498)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.247,325.545l-9.98.482a.655.655,0,0,1-.65-.515l-1.612-8.09a.451.451,0,0,1,.329-.547h0a.441.441,0,0,1,.1-.014l10.005-.363a.653.653,0,0,1,.636.515l1.589,7.973a.448.448,0,0,1-.323.546.394.394,0,0,1-.1.014m-9.655-.629,8.913-.419-1.375-6.917-8.933.336Z",
    transform: "translate(-375.741 -280.938)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.258,324.961l-9.653.465a.639.639,0,0,1-.629-.507l-1.583-7.953a.439.439,0,0,1,.312-.537h0a.442.442,0,0,1,.1-.014l9.674-.352a.639.639,0,0,1,.616.507l1.56,7.842a.439.439,0,0,1-.312.535h0a.555.555,0,0,1-.093.014m-9.34-.624,8.619-.407-1.354-6.8-8.633.326Z",
    transform: "translate(-375.147 -280.959)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.872,324.393l-9.34.45a.623.623,0,0,1-.609-.5l-1.557-7.823a.428.428,0,0,1,.3-.524.394.394,0,0,1,.1-.014l9.358-.34a.621.621,0,0,1,.6.5l1.535,7.714a.427.427,0,0,1-.3.524h0a.447.447,0,0,1-.091.016m-9.035-.62,8.338-.391-1.331-6.69-8.353.314Z",
    transform: "translate(-374.572 -280.979)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.116,323.84l-9.035.437a.609.609,0,0,1-.593-.491l-1.532-7.7a.419.419,0,0,1,.292-.516.5.5,0,0,1,.1-.016l9.06-.328a.609.609,0,0,1,.582.489l1.511,7.588a.419.419,0,0,1-.287.518.314.314,0,0,1-.093.014m-8.755-.616,8.069-.377-1.31-6.583-8.085.3Z",
    transform: "translate(-374.016 -280.999)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.006,323.31l-8.755.419a.6.6,0,0,1-.576-.484l-1.508-7.572a.4.4,0,0,1,.271-.505.392.392,0,0,1,.1-.018l8.774-.321a.6.6,0,0,1,.565.484l1.488,7.471a.406.406,0,0,1-.268.507h0a.433.433,0,0,1-.1.018m-8.481-.609,7.816-.365-1.289-6.48-7.832.294Z",
    transform: "translate(-373.479 -281.018)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.558,322.794l-8.489.406a.582.582,0,0,1-.559-.477l-1.485-7.453a.406.406,0,0,1,.281-.5h0a.416.416,0,0,1,.081-.014l8.5-.3a.583.583,0,0,1,.548.477l1.467,7.355a.4.4,0,0,1-.269.5h0a.344.344,0,0,1-.08.016m-8.222-.609,7.575-.355-1.27-6.379-7.588.287Z",
    transform: "translate(-372.958 -281.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.781,322.292l-8.221.4a.57.57,0,0,1-.546-.468l-1.462-7.336a.392.392,0,0,1,.261-.489h0a.334.334,0,0,1,.09-.018l8.244-.3a.567.567,0,0,1,.532.471l1.442,7.242a.392.392,0,0,1-.25.494h0a.506.506,0,0,1-.088.018m-7.973-.609,7.342-.344-1.248-6.281-7.358.275Z",
    transform: "translate(-372.453 -281.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.401 46.216)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.383 -4.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.953,331.817l12.829,9.632,12.606-9.8-12.829-9.628Z",
    transform: "translate(-378.953 -322.019)",
    fill: "url(#j)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M409.244,334.968l-9.623.6a.628.628,0,0,1-.629-.5l-1.583-7.96a.446.446,0,0,1,.419-.559l9.641-.487a.628.628,0,0,1,.609.5l1.563,7.841a.448.448,0,0,1-.314.546.379.379,0,0,1-.083.019m-9.313-.495,8.593-.524-1.354-6.8-8.61.445Z",
    transform: "translate(-375.05 -280.479)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.831,334.232l-9.311.583a.615.615,0,0,1-.609-.487l-1.557-7.823a.436.436,0,0,1,.31-.534h0a.374.374,0,0,1,.1-.014l9.332-.472a.609.609,0,0,1,.6.494l1.535,7.714a.432.432,0,0,1-.3.531h0a.356.356,0,0,1-.088.014m-9.013-.495,8.315-.507-1.331-6.69-8.33.432Z",
    transform: "translate(-374.477 -280.507)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.042,333.524l-9.013.564a.6.6,0,0,1-.593-.484l-1.532-7.694a.427.427,0,0,1,.3-.524.543.543,0,0,1,.091-.014l9.035-.456a.6.6,0,0,1,.58.484l1.509,7.588a.419.419,0,0,1-.283.521l-.012,0a.405.405,0,0,1-.08.014m-8.73-.5,8.051-.489-1.312-6.583-8.069.419Z",
    transform: "translate(-373.923 -280.534)",
    fill: "#f7f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.737,284.832l-10.227-.074-.437-2.191,10.232.1Z",
    transform: "translate(-376.073 -282.566)",
    fill: "#8a8d90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.037,284.923l-9.886-.072-.428-2.154,9.891.1Z",
    transform: "translate(-375.466 -282.56)",
    fill: "#8a8d90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.931,285.005l-9.56-.07-.419-2.117,9.565.1Z",
    transform: "translate(-374.879 -282.554)",
    fill: "#8a8d90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.44,285.087l-9.249-.067-.419-2.083,9.255.093Z",
    transform: "translate(-374.312 -282.548)",
    fill: "#8a8d90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.582,285.168l-8.955-.065-.406-2.05,8.959.091Z",
    transform: "translate(-373.763 -282.543)",
    fill: "#8a8d90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.374,285.244l-8.675-.064-.406-2.016,8.679.088Z",
    transform: "translate(-373.232 -282.537)",
    fill: "#8a8d90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.833,285.32l-8.406-.062-.4-1.985,8.411.085Z",
    transform: "translate(-372.717 -282.532)",
    fill: "#8a8d90"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M457.332,281.055l-81.785-1.136-.824-4.141,81.872,1.572Z",
    transform: "translate(225.292 -66.252)",
    fill: "#dbdcdd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(593.594 204.746)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.8,309.606c-18.314-9.947-35.67-2.217-48.167-14.986-6.407-6.545-8.464-15.382-8.83-23.194l-8.056-.2a1.984,1.984,0,0,0-2.091,2.476l13.457,67.589a3.007,3.007,0,0,0,3.056,2.368l75.682-5.168c-8.318-16.893-17.5-24.788-25.047-28.887",
    transform: "translate(-368.595 -271.217)",
    fill: "#bbbdbf"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M436.725,291.538a1.083,1.083,0,0,0-1.414-.585,1.225,1.225,0,0,0-.223.125c-1.514,1.405-1.819,3.739-2.594,5.609-.593,1.426-1.258,2.823-1.894,4.231-1.362-1.944-2.538-4.035-3.945-5.949-.489-.664-1.656-.058-1.286.724,1.458,3.079,2.428,6.276,4.371,9.126a1.553,1.553,0,0,0,2.64-.3c1.126-2.285,2.274-4.562,3.249-6.917.761-1.832,1.944-4.11,1.092-6.061",
    transform: "translate(227.719 -65.528)",
    fill: "#dbdcdd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.968,321.281l30.333-1.319,34.948,1.224-34.478,7.536Z",
    transform: "translate(223.96 -64.133)",
    fill: "#252526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.613,349.832l-24.572-6.613a6.058,6.058,0,0,1-4.394-5.5V337.7a3.538,3.538,0,0,1,4.394-3.54l26.353,4.313Z",
    transform: "translate(223.753 -63.456)",
    fill: "#252526"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(592.02 272.412)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21.444 -6.392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.632,345.126l50.5,11.116L433.75,340.8l-50.5-11.116Z",
    transform: "translate(-346.632 -329.686)",
    fill: "url(#m)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(566.401 257.104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.717,345.245l-39.712,4.506a5.135,5.135,0,0,1-5.87-4.277,5.226,5.226,0,0,1-.062-.8v-.037a6.454,6.454,0,0,1,5.932-6.206l39.712-3.1a.419.419,0,0,1,.432.4.157.157,0,0,1,0,.044.51.51,0,0,1-.432.515l-39.712,3.233a5.2,5.2,0,0,0-4.762,5v.036a4.135,4.135,0,0,0,4.131,4.137,4.213,4.213,0,0,0,.629-.047l39.712-4.366a.407.407,0,0,1,.432.379h0a.21.21,0,0,1,0,.051.524.524,0,0,1-.432.524",
    transform: "translate(-341.524 -320.499)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.645,339.119l-25.6-4.338c-2.472-.438-4.394-3.68-4.394-7.251v-.039c0-3.569,1.921-6.4,4.394-6.312l27.16,1.009Z",
    transform: "translate(-342.648 -321.178)",
    fill: "#393a3c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(592.02 257.751)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.818 -7.189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.183,334.436l52.472,11.555,31.394-19.5-52.472-11.555Z",
    transform: "translate(-348.183 -314.935)",
    fill: "url(#o)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582.064 257.067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.717,336.021l-39.712,3.1c-3.249.256-5.932-3.4-5.932-8.157V330.9c0-4.755,2.687-8.691,5.932-8.77l39.712-.988c.238-.005.432.314.432.712s-.194.724-.432.734l-39.712,1.19c-2.608.08-4.762,3.249-4.762,7.068v.052c0,3.82,2.154,6.768,4.762,6.579l39.712-2.9c.238-.018.432.29.432.686s-.194.734-.432.752",
    transform: "translate(-357.187 -321.143)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.99,335.41l-5.474-.957a15.467,15.467,0,0,1,0-10.521l5.474.389a20.1,20.1,0,0,0,0,11.089",
    transform: "translate(-357.594 -321.009)",
    fill: "#252526"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(590.86 170.754)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.014 -0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.757,
    height: 5.301,
    fill: "url(#q)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595.25 172.802)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.287 -0.454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.9,240.81l.323,4.082,2.594-.508L372.5,240.3Z",
    transform: "translate(-369.902 -240.302)",
    fill: "url(#s)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(605.431 173.463)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.222 -0.329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.679,241.421l.248,3.144,2.118-.369-.248-3.144Z",
    transform: "translate(-379.679 -241.052)",
    fill: "url(#u)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(601.837 170.862)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.049 0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.146,
    height: 4.951,
    fill: "url(#w)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(592.107 174.997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.8,262.972c1.64-1.474,3.4-3.964,2.74-4.925-1.035-1.5-6.666,2.694-9.859.826-1.838-1.074-3.392-4.466-1.436-15.186l-3.442-.261a28.255,28.255,0,0,0-3,11.175c0,.08-.01.2-.018.363-.1,2.34-.314,7.755,2.389,10.139,3.09,2.725,9.291.865,12.622-2.133",
    transform: "translate(-366.719 -242.801)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.739,256.27a2.891,2.891,0,0,0-1.816-.428c-1.563.22-2.039,1.978-3.553,3.491a9.354,9.354,0,0,1-5.037,2.45,11.717,11.717,0,0,1-8.5-2.2l-.14-.1c-6.9-5.186-5.189-16.107-5.1-16.648l-3.706.4c-.579,1.014-4.873,8.815-1.319,16.956a16.366,16.366,0,0,0,6.143,7.362c4.068,2.57,7.037,1.641,17.37,1.856,12.129.256,14.9,1.677,16-.153,2.1-3.5-7.536-11.462-10.349-12.978",
    transform: "translate(-367.177 -242.83)",
    fill: "#e9eaea"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(609.551 163.005)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.177 0.003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.524,
    height: 30.514,
    fill: "url(#y)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640.697 189.032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.3,256.274c.794.25.673,1.331,2.327,3.773a11.519,11.519,0,0,0,2.614,3.072c3.249,2.342,7.013-.125,8.882,2.1a2.65,2.65,0,0,1,.641,2.528c-.7,1.467-3.884.779-14.82-.373-4.44-.466-5.521-.524-6.078-1.476-1.747-2.979,4.154-10.347,6.439-9.621",
    transform: "translate(-413.543 -256.222)",
    fill: "#dbdcdd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.776,266.815l-17.552-.3a.743.743,0,0,0-.609.3l-.535.745a.57.57,0,0,0,.445.9l18.576.516Z",
    transform: "translate(-413.522 -255.729)",
    fill: "#9a9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.1,258.686l-18.1-.838a1.526,1.526,0,0,0-1.34.68l-6.985,10.6,19.14.5a1.554,1.554,0,0,0,1.319-.67l6.437-9.306a.608.608,0,0,0-.143-.848h0a.618.618,0,0,0-.329-.113",
    transform: "translate(-413.009 -256.144)",
    fill: "#dbdcdd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.664,258.525a1.521,1.521,0,0,1,1.34-.681l.4.019a2.837,2.837,0,0,0,.494,1.589c1.025,1.421,2.934.71,4.218,2.224,1.413,1.664-.111,3.434,1.153,4.974,1.326,1.623,3.713.532,6.3,1.687l-.424.609a1.554,1.554,0,0,1-1.319.67l-19.14-.5Z",
    transform: "translate(-413.008 -256.145)",
    fill: "#dbdcdd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(618.781 184.916)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.187 -4.633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.818,253.762,394.8,275.21l36.72-5.888-9.981-21.449Z",
    transform: "translate(-384.818 -247.874)",
    fill: "url(#aa)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(618.781 184.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.163,253.009c1.409.567,2.893,1.144,3.681,2.528,1.476,2.587.146,7.295-2.125,9.933-1.592,1.845-3.739,2.335-7.965,3.235-5.482,1.167-8.174,1.661-10.261.2-2.286-1.607-1.208-3.709-4.523-8.7-2.474-3.727-4.7-4.993-4.288-6.193.456-1.335,3.654-1.056,4.873-.949,4.8.419,5.127,2.62,8.214,2.485,3.624-.158,4.218-3.238,8.651-3.256a10.116,10.116,0,0,1,3.745.715",
    transform: "translate(-392.63 -252.289)",
    fill: "#dbdcdd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.111)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.048,261.5c1.886,1.21,3.227-.314,7.373-.321,5.692-.01,7.531,2.842,10.875,1.625a6.587,6.587,0,0,0,2.811-2.065,12.122,12.122,0,0,1-2.386,4.677c-1.592,1.845-3.742,2.334-7.971,3.235-5.481,1.165-8.174,1.661-10.259.2-2.286-1.607-1.208-3.709-4.521-8.7-2.476-3.727-4.7-4.993-4.29-6.193a1.15,1.15,0,0,1,.56-.614,7.7,7.7,0,0,1,4.466,2.291c1.972,2.18,1.286,4.544,3.343,5.859",
    transform: "translate(-392.63 -253.343)",
    fill: "#dbdcdd"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(639.214 183.046)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.051 -0.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.092,257.911l-1.061-8.279-8.908,1.029,1.061,8.279Z",
    transform: "translate(-411.124 -249.632)",
    fill: "url(#ad)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(643.88 181.613)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.724 -1.542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.989,254.841l2.369-4.888-5.055-2.281-2.368,4.885Z",
    transform: "translate(-414.935 -247.672)",
    fill: "url(#af)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(645.143 197.517)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ag)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.506 -0.284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.861,264.048,417.3,267l5.26.307.559-2.956Z",
    transform: "translate(-417.302 -264.048)",
    fill: "url(#ah)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M418.645,265a17.02,17.02,0,0,0-2.969-.8c-2.474-.432-3.409-.028-4.544-.734a4.235,4.235,0,0,1-1.905-3.382c.008-2.358,2.635-3.372,2.64-6.34,0-.629-.118-.8-.21-.886-.988-.923-5.653,1.248-7.919,4.917-.524.849-2.813,4.852-1.02,8.323,2.039,3.959,8.057,4.689,12.018,3.052a10.054,10.054,0,0,0,3.818-2.841Z",
    transform: "translate(230.603 -67.362)",
    fill: "#dbdcdd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.093,328.693a6.9,6.9,0,0,1,1.173-1.9,10.635,10.635,0,0,1,1.6-1.511q.838-.644,2.2-1.553a24.727,24.727,0,0,0,3.211-2.557,5.029,5.029,0,0,0,1.545-2.557,6.03,6.03,0,0,0,.083-.74q0-1.69-1.923-1.69a2.883,2.883,0,0,0-1.86.592,2.736,2.736,0,0,0-.949,1.69,1.138,1.138,0,0,1-.477.655,1.544,1.544,0,0,1-.9.254,1.278,1.278,0,0,1-.771-.222.769.769,0,0,1-.306-.665,1.718,1.718,0,0,1,.019-.275,3.1,3.1,0,0,1,.974-1.6,5.662,5.662,0,0,1,2.006-1.162,8.017,8.017,0,0,1,2.686-.433,5.872,5.872,0,0,1,3.158.75,2.516,2.516,0,0,1,1.2,2.293,4.508,4.508,0,0,1-.086.888,4.937,4.937,0,0,1-1.782,2.842,23.408,23.408,0,0,1-3.773,2.5,27.15,27.15,0,0,0-2.811,1.723,3.661,3.661,0,0,0-1.372,1.677l-.044.21h5.918a1.414,1.414,0,0,0,1.121-.518,5.025,5.025,0,0,0,.782-1.342h.676l-1.058,3.973h-10.51Z",
    transform: "translate(228.847 -64.369)",
    fill: "#0f0f0f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondIcon);
export default __webpack_public_path__ + "static/media/second-icon.8cf79840aa30edc339e6794328240368.svg";
export { ForwardRef as ReactComponent };